// MessageCategory.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import CategoryItem from '../component/CategoryItem.jsx';

const MessageCategory = ({ categories = [], styles = {} }) => {
  if (!categories?.length) return null;
  return (
    <Container style={styles}>
      {categories.map(item => (
        <CategoryItem key={item} categoryId={item} isLink={true} />
      ))}
    </Container>
  );
};

MessageCategory.propTypes = {
  categories: PropTypes.array,
  styles: PropTypes.object,
};

const Container = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export default withTranslation()(MessageCategory);
